import React, { Component } from 'react';
import { connect } from 'react-redux'
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import Select from 'react-select';
import { gerarHashForString } from '../../../util/stringUtil';
import { tipoLink } from '../../../util/constantsUtil';

const renderField = ({
    input,
    label,
    type,
    css,
    max,
    readOnly,
    meta: { touched, error }
}) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <input {...input} type={type}
                className={css}
                maxLength={max}
                style={{ borderColor: touched && error ? 'red' : '' }}
                disabled={readOnly}
                readOnly={readOnly} />
            {touched
                && (error && <span style={{ color: 'red' }}>{error}</span>)}
        </div>
    </div>
);

export class UsuarioLink extends Component {

    adicionarLink(tipoSelecionado) {
        if (this.props.url != null && this.props.url.length > 0) {
            const tipoLink = tipoSelecionado ? tipoSelecionado.value : null;
            const hashDosItensPreenchido = gerarHashForString(`${tipoLink}`)

            if (this.props.linksSelecionados.filter(it => it.hash === hashDosItensPreenchido).length === 0) {
                const linksSelecionados = this.props.linksSelecionados;
                linksSelecionados.push({
                    hash: hashDosItensPreenchido,
                    tipo: tipoLink,
                    url: this.props.url
                });
                this.props.alterarValoresLinksSelecionados(linksSelecionados);
            }

            this.props.changeFieldValue('formularioUsuarioLink', 'url', '');
            if (this.props.verificaSeNaoFoiAlteradoLinks != null) {
                this.props.verificaSeNaoFoiAlteradoLinks(false);
            }
        } else {
            this.aplicaEfeitoFadeUrl();
        }
    }

    removerItemSelecionado(hash) {
        this.props.alterarValoresLinksSelecionados(this.props.linksSelecionados.filter(it => !(it.hash === hash)));
        if (this.props.verificaSeNaoFoiAlteradoLinks != null) {
            this.props.verificaSeNaoFoiAlteradoLinks(false);
        }
    }

    exibirTabelaLink() {
        return (
            <div>
                <table className="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Url</th>
                            <th scope="col">Tipo</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.linksSelecionados && this.props.linksSelecionados.length === 0 ?
                            <tr className="alert alert-warning text-center mt-4" role="alert">
                                <td colSpan='4'>
                                    Nenhum item adicionado.
                                </td>
                            </tr>
                            : this.props.linksSelecionados && this.props.linksSelecionados.map(it => (
                                <tr key={it.hash}>
                                    <td>{it.url}</td>
                                    <td>{it.tipo}</td>
                                    <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                        <div onClick={() => this.removerItemSelecionado(it.hash)}>
                                            Remover
                                        </div>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        )
    }

    aplicaEfeitoFadeUrl() {
        document.querySelector(`.${this.props.classCss}`).classList.add('fadeUrl');
        if(this.props.ehUsuarioAgencia) {
            document.querySelector('input[name=url]').classList.add('fadeUrlBorder')
        }
        setTimeout(() => {
            document.querySelector(`.${this.props.classCss}`).classList.remove('fadeUrl');
            if(this.props.ehUsuarioAgencia) {
                document.querySelector('input[name=url]').classList.remove('fadeUrlBorder')
            }
        }, 5000)
    }

    aplicarFuncaoParaEventoOnBlur() {
        return this.props.ehUsuarioAgencia && this.props.linksSelecionados.length <= 0 && !this.props.url;
    }
    
    render() {

        return (
            <>
                <div className="col-12 col-sm-6 col-md-6">
                    <Field name="url" type="text" component={renderField} label="Url:"
                        css="form-control" value='' onBlur={() => this.aplicarFuncaoParaEventoOnBlur() ? this.aplicaEfeitoFadeUrl() : null} />
                    <span className={this.props.classCss}>Preencher campo url</span>
                </div>
                <div className="col-12 col-sm-6 col-md-6 mt-2">
                    <label htmlFor='tipoLink'>Tipo:</label>
                    <Select
                        ref={this.componentRef}
                        placeholder='Selecione...'
                        styles={{
                            control: base => ({
                                ...base,
                                height: 35,
                                minHeight: 32,
                                fontSize: 16,
                                width: '100%',
                                borderColor: '#e4e7ea',
                                cursor: 'pointer'
                            })
                        }}
                        value={null}
                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                        options={tipoLink.filter(it => this.props.linksSelecionados && !this.props.linksSelecionados.map(it => it.hash).includes(gerarHashForString(it.value)))
                            .map(elemento => ({
                                label: elemento.label,
                                value: elemento.value
                            }))}
                        onChange={e => this.adicionarLink(e)} />
                </div>
                <div className="col-12 col-sm-12 col-md-12 mt-2">
                    <div className="lista-table">
                        {this.exibirTabelaLink()}
                    </div>
                </div>
            </>
        )
    }
}

export function mapStateToProps(state) {
    return {
        tipoLink: formValueSelector('formularioUsuarioLink')(state, 'tipoLink'),
        url: formValueSelector('formularioUsuarioLink')(state, 'url'),
    }
}

export default connect(mapStateToProps, {
    changeFieldValue,
    formValueSelector
})(reduxForm({
    form: 'formularioUsuarioLink',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(UsuarioLink))
